import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import {
	Grid,
	Paper,
	Typography,
	Button,
	Popper,
	Grow,
	ClickAwayListener,
	MenuList,
	MenuItem,
	IconButton,
	Tabs,
	Tab,
	Box,
	Chip,
	Card,
	CardContent,
	Divider
} from "@mui/material";

import { withStyles } from "@mui/styles";

import dayjs from "dayjs";

import ls from "Localization";

import * as actions from "store/actions/marketing";

import { MdMoreVert, MdEmail, MdSms, MdNotifications, MdSettings, MdPeople } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";

import styles from "./styles";
import Report from "Components/Report";
import { MarketingStatus, MarketingUserStatus } from "Types/Marketing";
import PushAction from "Types/PushAction";
import { useNavigate, useParams } from "react-router-dom";

const ls2: any = ls;

function TabPanel(props: any) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-auto-tabpanel-${index}`}
			aria-labelledby={`scrollable-auto-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

export function MarketingDetail({
	classes,
	state: { item, loading },
	getMarketing,
	resendMarketing,
	clearValues
}: any) {
	const navigate = useNavigate();
	const { id } = useParams();
	const [openMenu, setOpenMenu] = useState(false);
	const [tab, setTab] = useState(0);

	const menuRef: React.RefObject<any> = useRef(null);

	const marketingUsersColumns = [
		{
			Header: ls.name,
			id: "name",
			accessor: (c: any) => {
				if (!c?.user) return "N/A";
				return `${c.user.name || ""} ${c.user.lastname || ""}`.trim() || "N/A";
			}
		},
		// {
		// 	Header: "E-mail",
		// 	id: "email",
		// 	accessor: (c) => ls[MarketingUserStatus[c.emailStatus]],
		// },
		// {
		// 	Header: "SMS",
		// 	id: "sms",
		// 	accessor: (c) => ls[MarketingUserStatus[c.smsStatus]],
		// },
		// {
		// 	Header: "WhatsApp",
		// 	id: "ahatsApp",
		// 	accessor: (c) => ls[MarketingUserStatus[c.whatsAppStatus]],
		// },
		{
			Header: "Push",
			id: "push",
			accessor: (c: any) => {
				if (!c || c.pushStatus === undefined || c.pushStatus === null) return "N/A";
				return ls2[MarketingUserStatus[c.pushStatus]] || "N/A";
			}
		}
	];

	useEffect(() => {
		clearValues();
		if (id) {
		getMarketing(id);
		}
	}, [clearValues, getMarketing, id]);

	const handleMenuClose = (event: MouseEvent | TouchEvent) => {
		if (menuRef.current && menuRef.current.contains(event.target)) {
			return;
		}

		setOpenMenu(false);
	};

	function handleMenuListKeyDown(event: any) {
		if (event.key === "Tab") {
			event.preventDefault();
			setOpenMenu(false);
		}
	}

	const handleResend = () => {
		resendMarketing(id, (err: any) => {
			if (err) {
				console.log(err);
				if (err.default) alert(err.default);
				else if (typeof err === "string") alert(err);
				else alert(JSON.stringify(err));
			} else {
				alert("Campanha reenviada");
			}
		});
	};

	if (!item) return null;

	const { 
		creationDate, 
		name, 
		status, 
		startAt, 
		users,
		economicMode,
		emailSubject,
		emailMessage,
		smsMessage,
		whatsAppMessage,
		whatsAppRestrict,
		pushTitle,
		pushMessage,
		pushAction,
		pushValue
	} = item;

	console.log(users);

	return (
		<Grid container justifyContent="center" spacing={5}>
			<Grid item xs={12}>
				<Paper className={classes.root}>
					{/* Header Section */}
					<Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
						<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
							<Box>
								<Typography variant="h4" component="h1" gutterBottom>
									📢 {name}
								</Typography>
								<Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
									<Chip 
										label={ls2[MarketingStatus[status]]} 
										color={status === 1 ? 'success' : status === 2 ? 'warning' : 'default'}
										size="small"
									/>
									{economicMode && (
										<Chip 
											label="💰 Modo Econômico" 
											color="info"
											size="small"
										/>
									)}
								</Box>
							</Box>
							
							<Box sx={{ display: 'flex', gap: 1 }}>
							<Button
									variant="contained"
								color="primary"
									onClick={() => navigate(`/Dashboard/Marketing/${id}/Edit`)}
									startIcon="✏️"
									size="large"
							>
								{ls.edit}
							</Button>

							<IconButton
								ref={menuRef}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								onClick={() => setOpenMenu(p => !p)}
									size="large"
							>
								<MdMoreVert />
							</IconButton>
							<Popper
								open={openMenu}
								anchorEl={menuRef.current}
								role={undefined}
								transition
								disablePortal
								placement="bottom-end"
							>
								{({ TransitionProps, placement }: any) => (
									<Grow
										{...TransitionProps}
										style={{
											transformOrigin:
												placement === "bottom" ? "right top" : "right bottom"
										}}
									>
										<Paper>
											<ClickAwayListener onClickAway={handleMenuClose}>
												<MenuList
													autoFocusItem={openMenu}
													id="menu-list-grow"
													onKeyDown={handleMenuListKeyDown}
												>
														<MenuItem onClick={handleResend}>🔄 Reenviar</MenuItem>
												</MenuList>
											</ClickAwayListener>
										</Paper>
									</Grow>
								)}
							</Popper>
							</Box>
						</Box>

						{/* Campaign Stats */}
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6} md={3}>
								<Card sx={{ textAlign: 'center', p: 1 }}>
									<CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
										<Typography variant="h4">👥</Typography>
										<Typography variant="h6">{users?.length || 0}</Typography>
										<Typography variant="body2" color="text.secondary">Destinatários</Typography>
									</CardContent>
								</Card>
							</Grid>
							
							<Grid item xs={12} sm={6} md={3}>
								<Card sx={{ textAlign: 'center', p: 1 }}>
									<CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
										<Typography variant="h4">📅</Typography>
										<Typography variant="body2">
							{dayjs(creationDate).format(ls.dateFormatWithoutSeconds)}
										</Typography>
										<Typography variant="body2" color="text.secondary">Criado em</Typography>
									</CardContent>
								</Card>
							</Grid>
							
							<Grid item xs={12} sm={6} md={3}>
								<Card sx={{ textAlign: 'center', p: 1 }}>
									<CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
										<Typography variant="h4">🚀</Typography>
										<Typography variant="body2">
											{startAt ? dayjs(startAt).format(ls.dateFormatWithoutSeconds) : "Não agendado"}
										</Typography>
										<Typography variant="body2" color="text.secondary">Envio programado</Typography>
									</CardContent>
								</Card>
							</Grid>
							
							<Grid item xs={12} sm={6} md={3}>
								<Card sx={{ textAlign: 'center', p: 1 }}>
									<CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
										<Typography variant="h4">📊</Typography>
										<Typography variant="h6">
											{[emailMessage, smsMessage, whatsAppMessage, (pushTitle && pushMessage)].filter(Boolean).length}
										</Typography>
										<Typography variant="body2" color="text.secondary">Canais configurados</Typography>
									</CardContent>
								</Card>
							</Grid>
						</Grid>
					</Box>

					{/* Tabs Section */}
					<Tabs
						value={tab}
						indicatorColor="primary"
						textColor="primary"
						onChange={(_, v) => setTab(v)}
						variant="scrollable"
						scrollButtons="auto"
						sx={{ borderBottom: 1, borderColor: 'divider' }}
					>
						<Tab 
							icon={<MdSettings />} 
							label="Visão Geral" 
							iconPosition="start"
							sx={{ minHeight: 48 }}
						/>
						<Tab 
							icon={<MdEmail />} 
							label="E-mail" 
							iconPosition="start"
							sx={{ minHeight: 48 }}
						/>
						<Tab 
							icon={<MdSms />} 
							label="SMS" 
							iconPosition="start"
							sx={{ minHeight: 48 }}
						/>
						<Tab 
							icon={<FaWhatsapp />} 
							label="WhatsApp" 
							iconPosition="start"
							sx={{ minHeight: 48 }}
						/>
						<Tab 
							icon={<MdNotifications />} 
							label="Push" 
							iconPosition="start"
							sx={{ minHeight: 48 }}
						/>
						<Tab 
							icon={<MdPeople />} 
							label="Destinatários" 
							iconPosition="start"
							sx={{ minHeight: 48 }}
						/>
					</Tabs>

					{/* Tab Panels */}
					<TabPanel value={tab} index={0}>
						<Box sx={{ mb: 2 }}>
							<Typography variant="h6" gutterBottom>
								📋 Resumo da Campanha
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
								Informações gerais sobre a campanha de marketing
							</Typography>
						</Box>
						
						<Grid container spacing={3}>
							<Grid item xs={12} md={6}>
								<Card>
									<CardContent>
										<Typography variant="h6" gutterBottom>📝 Informações Básicas</Typography>
										<Divider sx={{ mb: 2 }} />
										<Grid container spacing={2}>
											<Grid item xs={6}>
												<Typography variant="body2" color="text.secondary">Nome:</Typography>
												<Typography variant="body1">{name}</Typography>
											</Grid>
											<Grid item xs={6}>
												<Typography variant="body2" color="text.secondary">Status:</Typography>
												<Typography variant="body1">{ls2[MarketingStatus[status]]}</Typography>
											</Grid>
											<Grid item xs={6}>
												<Typography variant="body2" color="text.secondary">Criado em:</Typography>
												<Typography variant="body1">
													{dayjs(creationDate).format(ls.dateFormatWithoutSeconds)}
												</Typography>
											</Grid>
											<Grid item xs={6}>
												<Typography variant="body2" color="text.secondary">Programado para:</Typography>
												<Typography variant="body1">
													{startAt ? dayjs(startAt).format(ls.dateFormatWithoutSeconds) : "Não agendado"}
												</Typography>
											</Grid>
										</Grid>
									</CardContent>
								</Card>
							</Grid>
							
							<Grid item xs={12} md={6}>
								<Card>
									<CardContent>
										<Typography variant="h6" gutterBottom>⚙️ Configurações</Typography>
										<Divider sx={{ mb: 2 }} />
										<Box sx={{ mb: 2 }}>
											<Typography variant="body2" color="text.secondary">Modo Econômico:</Typography>
											<Typography variant="body1">
												{economicMode ? "✅ Ativado" : "❌ Desativado"}
											</Typography>
											{economicMode && (
												<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
													Prioriza canais mais baratos para reduzir custos
												</Typography>
											)}
										</Box>
										
										<Box>
											<Typography variant="body2" color="text.secondary">Canais configurados:</Typography>
											<Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
												{emailMessage && <Chip label="📧 E-mail" size="small" color="primary" />}
												{smsMessage && <Chip label="📱 SMS" size="small" color="primary" />}
												{whatsAppMessage && <Chip label="💚 WhatsApp" size="small" color="primary" />}
												{(pushTitle && pushMessage) && <Chip label="🔔 Push" size="small" color="primary" />}
											</Box>
										</Box>
									</CardContent>
								</Card>
							</Grid>
						</Grid>
					</TabPanel>

					<TabPanel value={tab} index={1}>
						<Box sx={{ mb: 2 }}>
							<Typography variant="h6" gutterBottom>
								📧 Configuração de E-mail
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
								Detalhes da campanha de e-mail
							</Typography>
						</Box>
						
						{emailSubject || emailMessage ? (
							<Grid container spacing={3}>
								{emailSubject && (
									<Grid item xs={12}>
										<Card>
											<CardContent>
												<Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'medium' }}>
													📝 Assunto do E-mail
												</Typography>
												<Typography variant="body1">{emailSubject}</Typography>
												<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
													{emailSubject.length} caracteres
												</Typography>
											</CardContent>
										</Card>
									</Grid>
								)}
								
								{emailMessage && (
									<>
										<Grid item xs={12}>
											<Card>
												<CardContent>
													<Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'medium' }}>
														✉️ Conteúdo do E-mail
													</Typography>
													<Box sx={{ 
														border: '1px solid #ddd', 
														borderRadius: 1, 
														p: 2, 
														bgcolor: '#fff',
														maxHeight: 400,
														overflow: 'auto'
													}}>
														<div dangerouslySetInnerHTML={{ __html: emailMessage }} />
													</Box>
												</CardContent>
											</Card>
										</Grid>
									</>
								)}
							</Grid>
						) : (
							<Card>
								<CardContent sx={{ textAlign: 'center', py: 4 }}>
									<Typography variant="h4" sx={{ mb: 2 }}>📧</Typography>
									<Typography variant="h6" color="text.secondary">
										Nenhuma configuração de e-mail encontrada
									</Typography>
									<Typography variant="body2" color="text.secondary">
										Esta campanha não possui conteúdo de e-mail configurado
									</Typography>
								</CardContent>
							</Card>
						)}
					</TabPanel>

					<TabPanel value={tab} index={2}>
						<Box sx={{ mb: 2 }}>
							<Typography variant="h6" gutterBottom>
								📱 Configuração de SMS
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
								Detalhes da campanha de SMS
							</Typography>
						</Box>
						
						{smsMessage ? (
							<Grid container spacing={3}>
								<Grid item xs={12} md={8}>
									<Card>
										<CardContent>
											<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium' }}>
												💬 Mensagem SMS
											</Typography>
											<Box sx={{ 
												border: '1px solid #ddd', 
												borderRadius: 2, 
												p: 2, 
												bgcolor: '#f5f5f5',
												fontFamily: 'monospace',
												fontSize: '14px',
												position: 'relative'
											}}>
												<Box sx={{ 
													position: 'absolute', 
													top: 8, 
													right: 8, 
													fontSize: '12px', 
													color: '#999' 
												}}>
													📱 SMS
												</Box>
												<Typography component="div" sx={{ mt: 2 }}>
													{smsMessage}
												</Typography>
											</Box>
											<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
												{smsMessage.length}/140 caracteres
											</Typography>
										</CardContent>
									</Card>
								</Grid>
							</Grid>
						) : (
							<Card>
								<CardContent sx={{ textAlign: 'center', py: 4 }}>
									<Typography variant="h4" sx={{ mb: 2 }}>📱</Typography>
									<Typography variant="h6" color="text.secondary">
										Nenhuma configuração de SMS encontrada
									</Typography>
									<Typography variant="body2" color="text.secondary">
										Esta campanha não possui conteúdo de SMS configurado
									</Typography>
								</CardContent>
							</Card>
						)}
					</TabPanel>

					<TabPanel value={tab} index={3}>
						<Box sx={{ mb: 2 }}>
							<Typography variant="h6" gutterBottom>
								💚 Configuração do WhatsApp
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
								Detalhes da campanha do WhatsApp
							</Typography>
						</Box>
						
						{whatsAppMessage ? (
							<Grid container spacing={3}>
								<Grid item xs={12} md={8}>
									<Card>
										<CardContent>
											<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium' }}>
												💬 Mensagem WhatsApp
											</Typography>
											<Box sx={{ 
												border: '1px solid #25d366', 
												borderRadius: 2, 
												p: 2, 
												bgcolor: '#f0f8f0',
												position: 'relative'
											}}>
												<Box sx={{ 
													display: 'flex',
													alignItems: 'center',
													gap: 1,
													mb: 2,
													fontSize: '14px',
													fontWeight: 'bold',
													color: '#25d366'
												}}>
													💚 WhatsApp Business
												</Box>
												<Typography component="div" sx={{ 
													fontSize: '14px',
													lineHeight: 1.4,
													whiteSpace: 'pre-line'
												}}>
													{whatsAppMessage}
												</Typography>
											</Box>
											<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
												{whatsAppMessage.length} caracteres
											</Typography>
										</CardContent>
									</Card>
								</Grid>
								
								<Grid item xs={12} md={4}>
									<Card>
										<CardContent>
											<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium' }}>
												⚙️ Configurações
											</Typography>
											<Box>
												<Typography variant="body2" color="text.secondary">Modo Restrito:</Typography>
												<Typography variant="body1">
													{whatsAppRestrict ? "✅ Ativado" : "❌ Desativado"}
												</Typography>
												{whatsAppRestrict && (
													<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
														Apenas usuários autorizados receberão a mensagem
													</Typography>
												)}
											</Box>
										</CardContent>
									</Card>
								</Grid>
							</Grid>
						) : (
							<Card>
								<CardContent sx={{ textAlign: 'center', py: 4 }}>
									<Typography variant="h4" sx={{ mb: 2 }}>💚</Typography>
									<Typography variant="h6" color="text.secondary">
										Nenhuma configuração de WhatsApp encontrada
									</Typography>
									<Typography variant="body2" color="text.secondary">
										Esta campanha não possui conteúdo de WhatsApp configurado
									</Typography>
								</CardContent>
							</Card>
						)}
					</TabPanel>

					<TabPanel value={tab} index={4}>
						<Box sx={{ mb: 2 }}>
							<Typography variant="h6" gutterBottom>
								🔔 Configuração de Push Notification
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
								Detalhes das notificações push
							</Typography>
						</Box>
						
						{(pushTitle || pushMessage) ? (
							<Grid container spacing={3}>
								<Grid item xs={12} md={8}>
									<Card>
										<CardContent>
											<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium' }}>
												📱 Preview da Notificação
											</Typography>
											<Box sx={{ 
												border: '1px solid #1976d2', 
												borderRadius: 2, 
												p: 2, 
												bgcolor: '#f5f7fa',
												maxWidth: 350,
												position: 'relative'
											}}>
												<Box sx={{ 
													display: 'flex',
													alignItems: 'center',
													gap: 1,
													mb: 1,
													fontSize: '12px',
													color: '#666'
												}}>
													🔔 Push Notification
												</Box>
												<Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
													{pushTitle || 'Sem título'}
												</Typography>
												<Typography variant="body2" color="text.secondary">
													{pushMessage || 'Sem mensagem'}
												</Typography>
											</Box>
											
											{(pushTitle || pushMessage) && (
												<Box sx={{ mt: 2 }}>
													<Typography variant="body2" color="text.secondary">
														Título: {pushTitle?.length || 0} caracteres | 
														Mensagem: {pushMessage?.length || 0} caracteres
													</Typography>
												</Box>
											)}
										</CardContent>
									</Card>
						</Grid>

								<Grid item xs={12} md={4}>
									<Card>
										<CardContent>
											<Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium' }}>
												🎯 Ação da Notificação
											</Typography>
											<Box>
												<Typography variant="body2" color="text.secondary">Ação:</Typography>
												<Typography variant="body1">
													{pushAction !== undefined ? ls2[PushAction[pushAction]] || 'Não definido' : 'Não definido'}
												</Typography>
												
												{pushValue && (
													<Box sx={{ mt: 2 }}>
														<Typography variant="body2" color="text.secondary">Valor:</Typography>
														<Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
															{pushValue}
														</Typography>
													</Box>
												)}
											</Box>
										</CardContent>
									</Card>
						</Grid>
					</Grid>
						) : (
							<Card>
								<CardContent sx={{ textAlign: 'center', py: 4 }}>
									<Typography variant="h4" sx={{ mb: 2 }}>🔔</Typography>
									<Typography variant="h6" color="text.secondary">
										Nenhuma configuração de Push encontrada
									</Typography>
									<Typography variant="body2" color="text.secondary">
										Esta campanha não possui notificações push configuradas
									</Typography>
								</CardContent>
							</Card>
						)}
					</TabPanel>

					<TabPanel value={tab} index={5}>
						<Box sx={{ mb: 2 }}>
							<Typography variant="h6" gutterBottom>
								👥 Destinatários da Campanha
							</Typography>
							<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
								Lista de usuários que receberão esta campanha
							</Typography>
						</Box>
						
						<Report
							titleText=""
							title=""
							data={users}
							filterable
							defaultFilterMethod={(filter, row) =>
								String(row[filter.id])
									.toLowerCase()
									.indexOf(filter.value.toLowerCase()) > -1
							}
							columns={marketingUsersColumns}
							loading={loading.getTransactions}
							defaultSorted={[
								{
									id: "name",
									desc: true
								}
							]}
						/>
					</TabPanel>
				</Paper>
			</Grid>
		</Grid>
	);
}

const mapStateToProps = ({ marketing: state, login }: any) => ({
	state,
	login
});

const mapDispatchToProps = {
	...actions
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MarketingDetail));
